import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_BACKEND_URL;

export default class ApiClient {
  constructor(site = null) {
    this.base_url = BASE_API_URL;
    this.site = site;
  }

  buildUrl(url) {
    if (!this.site) return url;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}site=${encodeURIComponent(this.site)}`;
  }

  BaseURL() {
    return this.base_url;
  }

  isAuthenticated() {
    return localStorage.getItem("user") !== null;
  }

  authToken() {
    return localStorage.getItem("user");
  }

  authHeader() {
    // return auth header with jwt if user is logged in and request is to the api url
    const token = this.authToken();
    const isLoggedIn = !!token;
    return {
      headers: {
        Authorization: isLoggedIn ? `Bearer ${token}` : "",
      },
    };
  }

  requestOptions(options = {}) {
    return {
      ...options,
      headers: {
        ...this.authHeader().headers,
        ...(options.headers || {}),
      },
    };
  }

  handleError(err) {
    return {
      error: err.response?.data || {
        message: err.message || "Erreur réseau",
      },
    };
  }

  async get(url, options = {}) {
    return axios
      .get(this.base_url + this.buildUrl(url), this.requestOptions(options))
      .then((resp) => resp.data)
      .catch((err) => this.handleError(err));
  }

  async post(url, payload = {}, options = {}) {
    return axios
      .post(this.base_url + this.buildUrl(url), payload, this.requestOptions(options))
      .then((resp) => resp.data)
      .catch((err) => this.handleError(err));
  }

  async put(url, payload = {}, options = {}) {
    return axios
      .put(this.base_url + this.buildUrl(url), payload, this.requestOptions(options))
      .then((resp) => resp.data)
      .catch((err) => this.handleError(err));
  }

  async delete(url, options = {}) {
    return axios
      .delete(this.base_url + this.buildUrl(url), this.requestOptions(options))
      .then((resp) => resp.data)
      .catch((err) => this.handleError(err));
  }
}
